const initCatalogEth = {
    catalogsEth: [],
    currentPage: 1,
    totalPage: 1,
    limitPage: 10,
    lengthPage: 1,
    searchValue: "",
    filterTenantPage: "",
    isFormLoading: false,
  };
  
  export const catalogEthReducer = (state = initCatalogEth, action: any) => {
    if (action.type === "SET_CATALOG_ETH") {
      return {
        ...state,
        catalogsEth: action.value,
      };
    }
    if (action.type === "SET_CATALOG_ETH_CURRENT_PAGE") {
      return {
        ...state,
        currentPage: action.currentPage,
      };
    }
    if (action.type === "SET_CATALOG_ETH_PAGE") {
      return {
        ...state,
        totalPage: action.totalPage,
        limitPage: action.limitPage,
        lengthPage: action.lengthPage,
      };
    }
    if (action.type === "SET_SEARCH_CATALOG_ETH") {
      return {
        ...state,
        searchValue: action.searchValue,
      };
    }
    if (action.type === "SET_CATALOG_ETH_FILTER_PAGE") {
      return {
        ...state,
        filterTenantPage: action.filterTenantPage,
      };
    }
    if (action.type === "SET_FORM_LOADING") {
      return {
        ...state,
        isFormLoading: action.value,
      };
    }
    return state;
  };
  